import { useState } from 'react';

import { useGetUsersQuery } from '@/modules/users';
import { useShowResponseStatus } from '@/shared';

import type { TGetUsers } from '@/modules/users/store/types';

const initialParams: TGetUsers = {
  pageSize: 30,
  page: 1,
  ascending: false,
};

export const useGetUsers = () => {
  const [params, setParams] = useState<TGetUsers>(initialParams);
  const { data, isLoading, isError } = useGetUsersQuery(params);
  const itemsCount = data?.count;
  const items = data?.items ?? [];

  useShowResponseStatus({
    isError,
    errorMassage: 'Произошла ошибка!',
  });

  const handleFilterChange = (data: TGetUsers) => {
    setParams({ ...initialParams, ...data });
  };

  const handleFilterReset = () => {
    setParams({ ...initialParams });
  };

  const handlePaginationChange = (page: number) => {
    setParams((prev) => ({
      ...prev,
      page,
    }));
  };

  return {
    initialParams,
    params,
    items,
    itemsCount,
    isLoading,
    handleFilterChange,
    handleFilterReset,
    handlePaginationChange,
  };
};
